export const Create = () => import("./Create.vue");
export const NewOld = () => import("./_New.vue");
export const Edit = () => import("./Edit.vue");
export const List = () => import("./List.vue");
export const Show = () => import("./Show.vue");
export const Print = () => import("./Print.vue");
export const MyPending = () => import("./MyPending.vue");
export const Status = () => import("./Status.vue");
